import { create } from "zustand";

type EmailStore = {
  email: string;
  setEmail: (email: string) => void;
  clear: () => void;
};

export const useEmailStore = create<EmailStore>((set) => ({
  email: "",
  setEmail: (email) => {
    email = email.trim();
    set({ email });
  },
  clear: () => set({ email: "" }),
}));
